/**
 * pages/Login.jsx
 */
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "../components/UI";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", background: "#0F172A",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <div style={{ width: 380, padding: 40, background: "#1E293B", borderRadius: 16, border: "1px solid #334155" }}>
        <div style={{ marginBottom: 32, textAlign: "center" }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>
            Oracle Cloud Intelligence
          </div>
          <h1 style={{ fontSize: 26, fontWeight: 800, color: "#F1F5F9", margin: 0, fontFamily: "'DM Sans',sans-serif" }}>
            Cost Platform
          </h1>
          <p style={{ color: "#64748B", fontSize: 13, marginTop: 8 }}>Sign in to your account</p>
        </div>

        {error && (
          <div style={{ background: "#450A0A", border: "1px solid #7F1D1D", borderRadius: 8, padding: "10px 14px", color: "#FCA5A5", fontSize: 13, marginBottom: 20 }}>
            {error}
          </div>
        )}

        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: "#94A3B8", display: "block", marginBottom: 6 }}>Email</label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="admin@example.com" required
              style={{
                width: "100%", padding: "10px 14px", background: "#0F172A",
                border: "1px solid #334155", borderRadius: 8, color: "#F1F5F9",
                fontSize: 14, fontFamily: "'DM Sans',sans-serif",
              }}
            />
          </div>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: "#94A3B8", display: "block", marginBottom: 6 }}>Password</label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••" required
              style={{
                width: "100%", padding: "10px 14px", background: "#0F172A",
                border: "1px solid #334155", borderRadius: 8, color: "#F1F5F9",
                fontSize: 14, fontFamily: "'DM Sans',sans-serif",
              }}
            />
          </div>
          <button
            type="submit" disabled={loading}
            style={{
              marginTop: 8, padding: "11px", background: "#2563EB", color: "#fff",
              border: "none", borderRadius: 8, fontSize: 15, fontWeight: 700,
              cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1,
              display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            {loading && <Spinner size={16} color="#fff" />}
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p style={{ color: "#475569", fontSize: 11, textAlign: "center", marginTop: 24 }}>
          OCI Cost Intelligence Platform v1.0
        </p>
      </div>
    </div>
  );
}
